import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import { IconButton, Collapse, Card, CardHeader, CardContent } from '@material-ui/core'
import { ExpandMore, ExpandLess } from '@material-ui/icons'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { FileUploadCell } from 'components'
import { AttachmentInformationContainer, AttachmentDisplayContainer } from './styled'
import { isNullOrEmpty } from 'core/utilities'

const AttachmentInformation = (props) => {
  const { valueForm={}, change, isDisplay=false } = props
  const [showAttachmentInformation, setShowAttachmentInformation] = useState(true)

  const editableForm = () => {
    if (valueForm.status !== 0 && valueForm.status !== undefined && valueForm.status !== null) {
      return !isDisplay && !isNullOrEmpty(valueForm.sn) && !isNullOrEmpty(valueForm.requestType)
    } else {
      if (valueForm.creator === props.username) {
        return !isDisplay && !isNullOrEmpty(valueForm.requestType)
      } else {
        return false
      }
    }
  }

  return (
    <Card style={{ marginTop: '10px' }}>
      <CardHeader 
        title='Attachment'
        action={
          <IconButton aria-label='Expand' onClick={() => setShowAttachmentInformation(!showAttachmentInformation) }>
            {showAttachmentInformation ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        }
      />
      <Collapse in={showAttachmentInformation}>
        <CardContent>
          {
            editableForm() ?
              <AttachmentInformationContainer>
                <div className='rowFields'>
                  <Field 
                    name='BG04' 
                    label='Letter from vendor' 
                    require 
                    editable={editableForm()} 
                    replaceUpload
                    clearFiles={() => {
                      change('attachment04', [])
                    }}
                    showOldFile
                    oldFiles={valueForm.attachment04 || []}
                    removeOldFiles={(index, documentCode) => {
                      var clone = [...valueForm.attachment04]
                      clone.splice(index, 1)
                      change('attachment04', [...clone])
                    }}
                    type={type.file} 
                    component={FieldInput} />
                  <Field 
                    name='BG02' 
                    label='Other' 
                    editable={editableForm()} 
                    oldFiles={valueForm.attachment02 || []}
                    showOldFile
                    removeOldFiles={(index, documentCode) => {
                      var clone = [...valueForm.attachment02]
                      clone.splice(index, 1)
                      change('attachment02', [...clone])
                    }}
                    type={type.file} 
                    component={FieldInput} />
                </div>
              </AttachmentInformationContainer> :
              <AttachmentInformationContainer style={{ flexDirection: 'row' }}>
                <AttachmentDisplayContainer>
                  <div className='title'>Letter from vendor</div>
                  {
                    (valueForm.attachment04 || []).length === 0 ?
                    <div className='emptyFile'>No file uploaded.</div> : 
                    (valueForm.attachment04 || []).map(a =>
                      <FileUploadCell 
                        key={a.name}
                        fileName={a.originalFilename}
                        fileSize={a.size}
                        urlPath={a.urlPath||null} 
                        deletable={false}
                      />
                    )
                  }
                </AttachmentDisplayContainer>
                <AttachmentDisplayContainer>
                  <div className='title'>Other</div>
                  {
                    (valueForm.attachment02 || []).length === 0 ?
                    <div className='emptyFile'>No file uploaded.</div> : 
                    (valueForm.attachment02 || []).map(a =>
                      <FileUploadCell 
                        key={a.name}
                        fileName={a.originalFilename}
                        fileSize={a.size}
                        urlPath={a.urlPath||null} 
                        deletable={false}
                      />
                    )
                  }
                </AttachmentDisplayContainer>
              </AttachmentInformationContainer>
          }
        </CardContent>
      </Collapse>
    </Card>
  )
}

const mapStateToProps = (state) => {
  return ({
    username: state.authen.user ? state.authen.user.username ? state.authen.user.username : '' : '',
  })
}
  
const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(AttachmentInformation)